import React from 'react'
import PropTypes from 'prop-types';

import { Button, ButtonToolbar, Checkbox, FormControl } from 'react-bootstrap'
import { InsetSection, TextInput, NumericInput, LabelGroup, Section, Flex } from '~/views';
import { updateAttribute } from '~/actions/BlueprintActions';
import { AttributeUpdater } from '~/actions';
import BaseAttributeEditor from './BaseAttributeEditor.jsx';
import { UpdaterSelector, UpdaterFactory } from '~/editors/updaters';

import style from './style.css'

export default class IntAttributeEditor extends React.Component {

  static propTypes = {
    attribute : PropTypes.object,
    blueprint : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props );
    this.changePath = BaseAttributeEditor.ChangePath.bind( this )
    this.onUpdaterChange = BaseAttributeEditor.OnUpdaterChange.bind( this )
    this.minValidator = this.minValidator.bind( this );
    this.maxValidator = this.maxValidator.bind( this );
    this.onSelectUpdater = this.onSelectUpdater.bind( this );
  }

  minValidator( v ) {
    return this.attribute.max == null || v < this.attribute.max;
  }

  maxValidator( v ) {
    return this.attribute.min == null || v > this.attribute.min;
  }

  onSelectUpdater( updater ) {
    this.changePath( 'sim/updater', updater, false )
  }

  render() {
    const attr = this.props.attribute;
    const blueprint = this.props.blueprint;
    if ( attr == null ) {
      return <div />
    }
    const iValue = attr.sim && attr.sim.initialValue
    const uProps = { attribute : attr, blueprint, onChange : this.onUpdaterChange }
    const updater = UpdaterFactory.createEditor( attr.sim && attr.sim.updater, uProps );

    return (
      <div>
        <BaseAttributeEditor {...this.props} />
        {this.props.children}
        <Section header={this.props.numberHeader === undefined ? 'Values' : this.props.numberHeader}>
          <Flex variant="vSpace" justify="space-between" wrap="wrap">
            <Flex.Layout grow={1} shrink={0} basis="140px">

              <LabelGroup>
                <label>Min</label>
                <NumericInput 
                  value={attr.min}
                  float
                  max={attr.max}
                  size={8}
                  onChange={( v, err ) => { this.changePath( 'min', v, err ) }} />
              </LabelGroup>
            </Flex.Layout>

            <Flex.Layout grow={1} shrink={0} basis="140px">
              <LabelGroup>
                <label>Max</label>
                <NumericInput 
                  value={attr.max}
                  float
                  min={attr.min}
                  size={8}
                  onChange={( v, err ) => { this.changePath( 'max', v, err ) }} />
              </LabelGroup>
            </Flex.Layout>
            <Flex.Layout grow={1} shrink={0} basis="140px" />
          </Flex>
        </Section>

        <Section header="Simulation">
          <Flex variant="vSpace" direction="column" align="stretch">
            <LabelGroup>
              <label>Initial Value</label>
              <NumericInput hint="Initial Value..." 
                value={attr.sim && attr.sim.initialValue}
                min={attr.min}
                max={attr.max}
                float
                onChange={( v, err ) => { this.changePath( 'sim/initialValue', v, err ) }} />
            </LabelGroup>
            <LabelGroup>
              <label>Update with</label>
              <UpdaterSelector attribute={attr} updater={attr.sim && attr.sim.updater} onSelect={this.onSelectUpdater} />
            </LabelGroup>

            {updater}
          </Flex>
        </Section>
      </div>
    ) 
  }
}
